<app-black-container>
  <div class="content" [ngSwitch]="screen">
    <form
      *ngSwitchCase="'login'"
      (ngSubmit)="onSubmit()"
      #form="ngForm"
      appPasswordMatch
    >
      <p *ngSwitchCase="'login'">
        {{ "REQUEST_PASSWORD.UPDATE" | translate: { email: coach.email } }}
      </p>
      <div class="password">
        <mat-form-field
          appearance="outline"
          value="null"
          class="form-field full-width"
          color="accent"
          [ngClass]="{
            textError:
              passwordRef &&
              passwordRef.control.hasError('invalidPassword') &&
              passwordRef.control.touched,
          }"
        >
          <mat-label>{{ "REQUEST_PASSWORD.PASS" | translate }}</mat-label>
          <input
            appearance="outline"
            name="password"
            [(ngModel)]="credentials.password"
            type="password"
            #passwordRef="ngModel"
            matInput
            appPasswordValidation
            [capitalLetters]="
              provisioningProfile?.passwordComplexity?.value.capitalLetters
            "
            [commonPasswords]="
              provisioningProfile?.passwordComplexity?.value.commonPasswords
            "
            [numbers]="provisioningProfile?.passwordComplexity?.value.numbers"
            [symbols]="provisioningProfile?.passwordComplexity?.value.symbols"
            [length]="provisioningProfile?.passwordComplexity?.value.length"
            required
          />
          <mat-error *ngIf="passwordRef?.errors?.required">
            {{ "FORM_ERRORS.REQUIRED_FIELD" | translate }}
          </mat-error>
          <mat-error
            *ngIf="credentials.password && passwordRef.errors?.invalidPassword"
          >
            {{ passwordRef.getError("textError") }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="password">
        <mat-form-field
          appearance="outline"
          value="null"
          class="form-field full-width"
          color="accent"
        >
          <mat-label>{{
            "REQUEST_PASSWORD.PASS_CONFIRM" | translate
          }}</mat-label>
          <input
            appearance="outline"
            id="passwordConfirmation"
            name="passwordConfirmation"
            matInput
            [(ngModel)]="credentials.confirm"
            #confirmationRef="ngModel"
            [errorStateMatcher]="errorMatcher"
            type="password"
            required
          />
          <mat-error *ngIf="confirmationRef?.errors?.required">
            {{ "FORM_ERRORS.REQUIRED_FIELD" | translate }}
          </mat-error>
          <mat-error
            *ngIf="credentials.confirm && form?.errors?.passwordsDoNotMatch"
          >
            {{ "FORM_ERRORS.PASSWORDS_DO_NOT_MATCH" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <button
        type="submit"
        mat-raised-button
        color="primary"
        [attr.aria-label]="'REQUEST_PASSWORD.DONE_ARIA' | translate"
        [disabled]="!form.valid || isLoading"
        class=""
      >
        {{ "REQUEST_PASSWORD.DONE" | translate }}
      </button>
    </form>
    <form
      autocomplete="off"
      (ngSubmit)="onSubmitMfa(mfaInput)"
      #mfaForm="ngForm"
      class="mfa-form"
      *ngSwitchCase="'mfa'"
    >
      <div class="title-container">
        <h1 class="title">
          {{ "MFA.TITLE" | translate }}
        </h1>
        <div>
          <p class="description">{{ "MFA.HINT" | translate }}</p>
          <div role="alert">
            <c-banner
              *ngIf="error"
              class="error-banner"
              [style]="'error'"
              [inline]="false"
              [message]="error.message | translate"
              [actionButtonText]="error.action | translate"
              [showCloseButton]="false"
              [iconPositionX]="'center'"
              (actionButtonClick)="goBackToLogin('cancelPressed')"
            ></c-banner>
          </div>
        </div>
      </div>
      <div class="flex-column gap-sm">
        <div class="input-container">
          <c-input-text
            name="verificationCode"
            type="text"
            [label]="'MFA.CODE' | translate"
            [(ngModel)]="mfaCode"
            [ngModelOptions]="{ updateOn: 'blur' }"
            #mfaInput="ngModel"
            maxLength="6"
            minLength="6"
            pattern="\d{6,6}"
            inputmode="numeric"
            class="full-width"
            required
          >
            <div error-container role="alert">
              <p
                *ngIf="mfaInput.touched && mfaInput.errors"
                class="input-error"
              >
                {{ "REGISTER.VERIFY_EMAIL.ERRORS.LENGTH" | translate }}
              </p>
            </div>
          </c-input-text>
        </div>
        <mat-checkbox
          name="mfaTrustDevice"
          [(ngModel)]="mfaTrustDevice"
          class="mfa-checkbox"
        >
          {{ "MFA.REMEMBER_DEVICE" | translate }}
        </mat-checkbox>
      </div>
      <div class="flex-column gap-sm">
        <c-button
          [text]="'MFA.CONTINUE' | translate"
          buttonType="neutral"
          buttonStyle="fill"
          size="large"
          type="submit"
          class="full-button"
        ></c-button>
        <c-button
          class="full-button"
          (onClick)="screen = 'login'"
          [text]="'MFA.CANCEL' | translate"
          buttonType="neutral"
          buttonStyle="ghost"
          size="large"
        >
        </c-button>
      </div>
      <p class="resend-text">
        <span>{{ "MFA.EMAIL.RESEND.TEXT" | translate }} </span>
        <button (click)="requestNewCode()" class="resend-text resend-button">
          {{ "MFA.RESEND_SMS" | translate }}
        </button>
        <span> {{ "MFA.EMAIL.RESEND.OR" | translate }} </span>
        <a class="resend-link" href="mailto:support@cariloop.com">
          {{ "MFA.EMAIL.RESEND.LINK_2" | translate }}
        </a>
      </p>
      <app-countdown
        (onEnd)="screen = 'mfaError'; mfaErrorLabel = 'MFA.TIMEOUT_ERROR'"
        [limit]="mfaLimit"
      ></app-countdown>
    </form>
    <div class="mfa-error" role="alert">
      <p class="mfa-error-text" *ngSwitchCase="'mfaError'">
        {{ mfaErrorLabel | translate }}
      </p>
    </div>
    <c-button
      *ngSwitchCase="'mfaError'"
      [text]="'MFA.BACK' | translate"
      buttonType="neutral"
      buttonStyle="fill"
      size="large"
      class="full-button"
      (onClick)="screen = 'mfa'; goBackToLogin('cancelPressed')"
    ></c-button>
  </div>
</app-black-container>
